import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataService } from '../../../_services/index';

@Component({
  selector: 'app-view-content',
  templateUrl: './view-content.component.html',
  styleUrls: ['./view-content.component.css']
})
export class ViewContentComponent implements OnInit {

  constructor(
    private _route: ActivatedRoute,
    private _dataService: DataService,
  ) { }
  content:any=null;
  ngOnInit() {
    this._route.params.subscribe(params => {
      let file = params.key;
      let type = /^.+\.([^.]+)$/.exec(file)[1];
      let contentType:string = null;
      if(type == 'pdf') contentType = 'application/pdf';
      else if(type == 'mp3') contentType = 'audio/mpeg';
      else if(type == 'png') contentType = 'image/png';
      else if(type == 'jpg' || type == 'jpeg') contentType = 'image/jpeg';

      this.getFileObject({key: file, type: contentType}).then((data)=>{
        let objectURL = URL.createObjectURL(data);
        window.location.href = objectURL;
      });
      
    });
  }

  getFileObject(options:{key: string, type: string}): Promise<any> {
		return new Promise((resolve, reject)=>{
			if (options.key) {
				const body = { 'key': options.key, type: options.type, responseType: 'blob' };
				this._dataService.post('/auth/getFile', body).subscribe((res: any) => {
					if(res.type !== options.type) {
						reject("ERROR: could not download file for preview.");
					} else {
						resolve(res);
					}
				});
			} else {
				reject("ERROR: No item selected");
			}
		});
	}

}



// WEBPACK FOOTER //
// ./public/app/modules/my-content/view-content/view-content.component.ts